// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3bSO2","row":"ProcedureTreatmentSummary_row__dt6RL"};